@if (placement().disqualifyReason && placementActions().requalify) {
  <rt-button
    variant="tertiary"
    (click)="onRequalifyClick()"
    layout-full-width
    margin-top-small
    margin-bottom-small-xx
  >
    <rt-icon name="settings-backup-restore" />
    {{ 'app.candidate.requalify' | translate }}
  </rt-button>
} @else {
  @if (placement().hiredInThisPlacement && placementActions().hire) {
    <rt-button
      variant="tertiary"
      (click)="editHiringDetailsClick.emit({ placement: placement() })"
      layout-full-width
      margin-top-small
      data-cy="candidate-profile-placement:edit-hiring-details-button"
    >
      <rt-icon name="edit" />
      {{ 'app.candidate.placements.edit_hiring_details' | translate }}
      @if (openingIssue() === RequisitionOpeningIssue.LIMIT_EXCEEDED) {
        <rt-icon
          [rtTooltip]="'app.candidate.placements.missing_opening_tooltip_v2' | translate"
          [rtTooltipMaxWidth]="435"
          [rtTooltipHasTextAlignCenter]="true"
          [colorToken]="$any('colorIconWarningDefault')"
          rtTooltipPosition="above"
          name="warning"
          size="small-x"
          margin-right-small-x
        />
      }
      @if (openingIssue() === RequisitionOpeningIssue.NOT_ASSIGNED) {
        <rt-icon
          [rtTooltip]="'app.candidate.placements.missing_opening_error_tooltip_v2' | translate"
          [rtTooltipMaxWidth]="425"
          [rtTooltipHasTextAlignCenter]="true"
          [colorToken]="$any('colorIconCriticalDefault')"
          rtTooltipPosition="above"
          name="error"
          size="small-x"
          margin-right-small-x
        />
      }
    </rt-button>
  }

  @if (showProceedAndDisqualifyButtons()) {
    <div layout layout-align-items-center margin-top-small margin-bottom-small-xx>
      @if (placementActions().disqualify) {
        <ng-template #disqualifyDropdownTrigger let-toggle="toggle">
          <rt-button variant="tertiary" [disabled]="isLoading()" (click)="toggle()">
            <rt-icon
              name="block"
              [colorToken]="
                $any(isLoading() ? 'colorIconDisabledDefault' : 'colorIconCriticalDefault')
              "
            />
            {{ 'app.candidate.disqualify' | translate }}
          </rt-button>
        </ng-template>

        <rt-disqualify-reasons-dropdown
          [collection]="disqualifyReasons()"
          [triggerTpl]="disqualifyDropdownTrigger"
          [hasEditOption]="true"
          [customDropdownPositions]="disqualifyDropdownPositions"
          withPush="false"
          (select)="disqualifyReasonClick($event.disqualifyReason)"
          (actionsDetails)="disqualifyReasonsActionsDetails.emit($event.disqualifyReason)"
          (edit)="editDisqualifyReasonsClick.emit()"
          margin-right-small
          base-width-half
        />
      }
      @if (placementActions().proceed) {
        <rt-button
          [rtWalkthroughOriginStepId]="'walkthrough-step-proceed-disqualify-2'"
          [rtTooltip]="proceedButtonTooltip()"
          [rtTooltipEnabled]="!!nextStage()"
          [rtTooltipPosition]="proceedButtonTooltipPosition()"
          [rtTooltipMaxWidth]="212"
          variant="tertiary"
          (click)="onProceedClick($event)"
          class="proceed-button"
          [class.disabled]="isProceedButtonDisabled()"
          base-width-half
          data-cy="candidate-profile:placement:proceed-button"
        >
          <rt-icon
            [name]="isNextStageHired() ? 'hired' : 'arrow-forward'"
            [colorToken]="
              $any(
                isProceedButtonDisabled() ? 'colorIconDisabledDefault' : 'colorIconSuccessDefault'
              )
            "
          />
          @if (isNextStageHired()) {
            {{ 'app.candidate.mark_as_hired' | translate }}
          } @else {
            {{ 'app.candidate.proceed' | translate }}
          }
        </rt-button>
      }
    </div>
  }
}
